// extracted by mini-css-extract-plugin
export var sectionCapacityWarning = "section__capacity-warning_PMtehYLtj1Cgg6dTQkjT";
export var sectionDateRange = "section__date-range_Sk4NB14doS8lcBE7Q7ug";
export var sectionProductName = "section__product-name_kVblhrQTMgJXMm84rwDl";
export var sectionProgressWrapper = "section__progress-wrapper_LsQ_x08SsJ853z1crwZ4";
export var sectionStatusDot = "section__status-dot_lhXq0l9bti24ALThVdLb";
export var sectionStatusDotActive = "section__status-dot_active_uuVbQj45cVH8VBPTwK_I";
export var sectionStatusDotScheduled = "section__status-dot_scheduled_rbVXWmgeh3f_iryoMMDg";
export var sectionStatusLabel = "section__status-label_yhP1Q0M3PQIvsNMNJu6j";
export var sectionStatusLabelActive = "section__status-label_active_UmraoSSLRnQpR6HurkYw";
export var sectionStatusLabelScheduled = "section__status-label_scheduled_B5dOGtMy4XHsiIWbsqTU";
export var sectionSubscriptionRow = "section__subscription-row_W8FzbsE0uA2iXKSIYo9r";